import { getContractAgreements } from '@engage/api-v2';
import { engageApi } from '../lib/singletons';
import { unwrap } from '../lib/unwrap';
import { toFetcher } from './toFetcher';
export var toContractAgreementsFetchers = function toContractAgreementsFetchers() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : engageApi;
  return {
    GetContractAgreements: toFetcher(function (_ref) {
      var userId = _ref.userId;
      return userId ? null : "ContractAgreements[".concat(userId, "]");
    }, function (_ref2) {
      var userId = _ref2.userId;
      return unwrap(function () {
        return getContractAgreements(api, userId);
      });
    }, {
      revalidateOnFocus: false
    })
  };
};